import { useApplication } from '@/hooks/useApplication';
import { useMetadata } from '@/hooks/useMetadata';
import { useUpdateNodes } from '@/hooks/useUpdateNodes';
import { findSubroutine } from '@/util/application';
import { getDependentNodes } from '@/util/array';
import { Stack } from '@mui/material';
import { FC } from 'react';
import Arguments from './Arguments';
import EventArguments from './EventArguments';
import ReturnTypes from './ReturnTypes';

type SubroutineViewProps = {
  id: number;
  parentSubroutineId: number | undefined;
};

const SubroutineView: FC<SubroutineViewProps> = ({ id, parentSubroutineId }) => {
  const { application, setApplication } = useApplication();
  const { metadata } = useMetadata();
  const { setUpdateNodes } = useUpdateNodes();
  const subroutine = findSubroutine(application.subroutines, parentSubroutineId);
  if (!parentSubroutineId || !subroutine) return <></>;

  const updateApp = () => {
    const newApp = { ...application };
    setApplication(newApp);
    setUpdateNodes(getDependentNodes(application, metadata, subroutine));
  };

  return (
    <Stack gap={1}>
      <EventArguments id={id} parentSubroutineId={parentSubroutineId} subroutine={subroutine} updateApp={updateApp} />
      <Arguments id={id} parentSubroutineId={parentSubroutineId} subroutine={subroutine} updateApp={updateApp} />
      <ReturnTypes subroutine={subroutine} updateApp={updateApp} />
    </Stack>
  );
};

export default SubroutineView;
